import { render } from "./projectsnamespaces.vue?vue&type=template&id=8bcbf3a4"
import script from "./projectsnamespaces.vue?vue&type=script&lang=js"
export * from "./projectsnamespaces.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__